import { render } from "./PBarPoint.vue?vue&type=template&id=48f7d97e&scoped=true"
import script from "./PBarPoint.vue?vue&type=script&lang=js"
export * from "./PBarPoint.vue?vue&type=script&lang=js"

import "./PBarPoint.vue?vue&type=style&index=0&id=48f7d97e&lang=sass&scoped=true"

import exportComponent from "D:\\Open Server 5.3.5\\OSPanel\\domains\\front\\personal_form\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f7d97e"]])

export default __exports__